export enum ScreeningResult {
  Approved = 'Approved',
  ApprovedWithConditions = 'Approved with Conditions',
  Denied = 'Denied',
}
